var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "var(--icon-color)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M764 4145 c-207 -45 -385 -225 -430 -434 -20 -98 -20 -2204 0 -2302 45 -211 224 -390 435 -435 98 -21 3484 -21 3582 0 211 45 390 224 435 435 20 98 20 2204 0 2302 -45 211 -224 390 -435 435 -95 20 -3494 19 -3587 -1z m3584 -217 c65 -26 130 -75 167 -126 59 -80 67 -118 73 -314 l4 -178 -2031 0 -2031 0 0 144 c0 79 5 167 10 197 28 145 140 260 281 288 24 5 818 8 1764 7 1597 -1 1723 -2 1763 -18z m240 -1655 c-3 -744 -5 -822 -20 -861 -41 -103 -124 -184 -223 -219 -47 -17 -149 -18 -1785 -18 -1636 0 -1738 1 -1785 18 -99 35 -182 116 -223 219 -15 39 -17 117 -20 861 l-3 817 2031 0 2031 0 -3 -817z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013 1798 c-57 -28 -67 -122 -17 -169 l26 -24 459 -3 c513 -3 507 -4 535 65 19 43 5 93 -33 123 -25 19 -39 20 -487 19 -298 0 -469 -4 -483 -11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.e33190e5c1736989d77e78bd675c0ebb.svg";
export { ForwardRef as ReactComponent };